var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.636 7.5 15.273 12h3.273c0 3.73-2.93 6.75-6.546 6.75a6.408 6.408 0 0 1-3.06-.782l-1.593 1.643A8.55 8.55 0 0 0 12 21c4.822 0 8.727-4.027 8.727-9H24l-4.364-4.5ZM5.455 12c0-3.73 2.929-6.75 6.545-6.75 1.107 0 2.144.287 3.06.782l1.593-1.643A8.55 8.55 0 0 0 12 3c-4.822 0-8.727 4.027-8.727 9H0l4.364 4.5L8.727 12H5.455Z",
    fill: "#fff"
  })));
};
export default SvgRefresh;